<div class="container-tig-item">
    <div class="help-c-title">
        <h4>嵌入办公软件</h4>
    </div>
    <div>
        <h4> 本教程适用版本：WPS Office 2019 PC版</h4>
        <br>
        <p>在利用PPT演示文稿进行日常办公时，制作幻灯片时经常会将文字设置成用户喜欢的字体，但在其他电脑打开时，却发现设置完成的字体却变为了默认字体，这该如何解决呢，今天小编就来教大家，PPT幻灯片当中如何嵌入字体的方法，一起来学习一下吧。</p>
        <br>
        <p>首先，打开一张幻灯片，将文字字体设置完毕，如下图所示：</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/office-1.jpg" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>单击工具栏【文件】下的【工具】，在下拉菜单下选择【选项】：</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/office-2.jpg" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>弹出【选项】的对话框，单击【常规与保存】，可以看到保存选项下，有【将字体嵌入文件】的选项：</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/office-3.jpg" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>
            在【将字体嵌入文件】旁边打钩，单击确定即可，这样再次在其他电脑打开时，文字就会显示原有字体，不会改变：
        </p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/office-4.jpg" alt="Onon字体 - 图片">
        </div>
        <br>
        <br>
    </div>
</div>